import { CustomStack } from 'modules/common/components';
import {
  selectTrendEndDate,
  selectTrendGranularity,
  selectTrendStartDate,
} from 'modules/dashboard/components/tab-container/trend-tabs/selectors';
import { trendActions } from 'modules/dashboard/components/tab-container/trend-tabs/slice';
import { useDispatch, useSelector } from 'react-redux';
import styles from 'modules/dashboard/components/tab-container/inner-filter/inner-filter.module.scss';
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import GRANULARITY from 'modules/common/constants/granularity';
import { differenceInDays } from 'date-fns';
import { useEffect } from 'react';

export default function GranularityRadio() {
  const trendGranularity = useSelector(selectTrendGranularity);
  const targetStartDate = useSelector(selectTrendStartDate);
  const targetEndDate = useSelector(selectTrendEndDate);
  //
  const dispatch = useDispatch();
  //
  useEffect(() => {
    const days = differenceInDays(new Date(targetEndDate), new Date(targetStartDate)) + 1;
    let granularity = '';
    if (days > 1460) {
      granularity = 'Yearly';
    } else if (days >= 364) {
      granularity = 'Monthly';
    } else if (days > 60) {
      granularity = 'Weekly';
    } else {
      granularity = 'Daily';
    }
    dispatch(trendActions.setTrendGranularity(granularity));
  }, [targetStartDate, targetEndDate]);
  //
  const handleGranularity = (event, newGranularity) => {
    dispatch(trendActions.setTrendGranularity(newGranularity));
  };
  //
  return (
    <CustomStack cssClassName={styles.innerFilter}>
      <Typography color="#0009">Granularity</Typography>
      <FormControl sx={{ mt: 1 }}>
        <RadioGroup
          value={trendGranularity}
          onChange={handleGranularity}
          id="granularity-radio-group"
        >
          {GRANULARITY.map((granularity) => (
            <FormControlLabel
              key={granularity}
              value={granularity}
              control={<Radio sx={{ py: 1.2 }} />}
              label={granularity}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </CustomStack>
  );
}
